<template>
    <div></div>
</template>

<script>
    export default {
        name: 'ZoomHint',
        data() {
            return {
                notify: null,// 弹窗组件
                notifyIsPresence: false,// 弹窗是否存在
            };
        },
        mounted() {
            // 不需要缩放提示的页面
            let path = [
                '/personalCenter/operationCenter/cargoQuery/exportBusiness/EntryMapMobile'
            ];
            if (path.includes(window.location.pathname)) {
                return;
            }
            // 如果是移动端不提醒
            if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
                return;
            }
            this.init();
        },
        methods: {
            // init
            init() {
                // 避免iframe嵌套时候，出现多个小弹窗
                try {
                    if (window.location.href !== window.top.location.href) {
                        return;
                    }
                } catch (e) {
                    return;
                }

                // 获取当前缩放比例
                let percentage = this.detectZoom();

                // 页面一进来 初始化判断是否显示提示
                this.$nextTick(() => {
                    if (localStorage.getItem('zoomStatus') !== '1') {
                        percentage !== 100 ? this.open() : this.close();
                    }
                });

                // 页面缩放时 判断是否显示提示
                window.addEventListener('resize', () => {
                    if (percentage !== this.detectZoom() && localStorage.zoomStatus !== '1') {
                        percentage = this.detectZoom();
                        percentage !== 100 ? this.open() : this.close();
                    }
                });
            },
            // 获取页面的缩放比例
            detectZoom() {
                let ratio = 0,
                    screen = window.screen,
                    ua = navigator.userAgent.toLowerCase();
                if (window.devicePixelRatio !== undefined) {
                    ratio = window.devicePixelRatio;
                } else if (~ua.indexOf('msie')) {
                    if (screen.deviceXDPI && screen.logicalXDPI) {
                        ratio = screen.deviceXDPI / screen.logicalXDPI;
                    }
                } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                    ratio = window.outerWidth / window.innerWidth;
                }
                if (ratio) {
                    ratio = Math.round(ratio * 100);
                }
                return ratio;
            },
            // 点击不再提醒
            noWarn() {
                localStorage.zoomStatus = '1';
                this.close();
            },
            // 弹窗显示
            open() {
                // 判断弹窗是否已经存在
                if (this.notifyIsPresence) {
                    return;
                }
                this.notifyIsPresence = true;
                let h = this.$createElement;
                this.notify = this.$notify({
                    message: h(
                        'div', {
                            style: 'width:97%;max-width:268px'
                        }, [
                            h('span', this.$t('message.zoom1')),
                            h('u', 'Ctrl'),
                            h('span', ` ${this.$t('message.and')} `),
                            h('u', '0'),
                            h('span', ` ${this.$t('message.zoom2')}`),
                            h('div', {
                                style: 'text-align:right;margin-top: 10px',
                            }, [
                                h('el-button', {
                                    attrs: {
                                        size: 'mini'
                                    },
                                    on: {
                                        click: this.noWarn
                                    },
                                }, this.$t('message.noRemind'))
                            ]),
                        ]
                    ),
                    position: 'bottom-left',
                    duration: 0,
                    onClose: () => {
                        this.notifyIsPresence = false;
                    }
                });
            },
            // 弹窗关闭
            close() {
                // 先判断弹窗是否存在
                if (this.notifyIsPresence) {
                    this.notifyIsPresence = false;
                    this.notify.close();
                }
            }
        }
    };
</script>

<style scoped>

</style>
